const trackingUtils = require('../modules/utils/tracking.utils');
const userAccountError = require('../modules/users/user_account_error');
const xsellFindBookingFactory = require('components/cross_selling/find_booking/js/main');
const downloadAppBannerFactory = require('components/app_download/download_app_banner/js/main');
const createWidgetLoader = require('components-framework/widget/create_widget_loader');

Odigeo.Router.handlers.accountcreditcards = function() {
    const pageName = 'accountcreditcards';
    const $page = $('#page');
    const widgetLoader = createWidgetLoader({
        xsellFindBooking: ['my-trips-with-find-booking', xsellFindBookingFactory],
        downloadAppBanner: ['download-app-banner', downloadAppBannerFactory],
    });

    $page.removeClass().addClass(pageName);

    Odigeo.Router.eventController = $.extend(
        Odigeo.Router.eventController,
        Odigeo.Router.handlers.globalEventController,
        Odigeo.Router.handlers.userEventController,
    );
    Odigeo.Router.eventController = $.extend(true, Odigeo.Router.eventController, {
        globalEvents: {
            'global:onGetDataError': 'onGetDataError',
        },
        viewEvents: {
            'users-manager:getAccountInfoOk': 'onGetAccountInfo',
            'users-manager:logOutOk': 'onGoToHomePage',
        },
        eventHandlers: {
            onGetDataError(data) {
                userAccountError.processError(data);
            },

            onGoToHomePage() {
                Odigeo.Utils.goToApplicationHome();
            },

            onGetAccountInfo(data) {
                $('#myInfoUserName').text(data.displayName ? data.displayName : '');
                widgetLoader.get('downloadAppBanner').execute('trackEventCategory', 'my_area_account');
            },
        },
    });

    Odigeo.Router.eventController.execute();

    const $personalAreaMenu = $('#personal_area_menu');
    const menu = Odigeo.UIElements.menu.enhanceMenu($personalAreaMenu);


    const _userManagerRequest = (data) => {
        Odigeo.requireWidget('users-manager', 'usersmanager', function(usersmanager) {
            usersmanager.execute('submitUserRequest', data);
        });
    };

    const _changePageTitle = () => {
        $personalAreaMenu
            .data('track-action', 'sidebar')
            .data('track-category', 'my_area_account');
    };

    _changePageTitle();
    _userManagerRequest({data: null, action: 'getAccountInfo'});

    if (menu) {
        menu.trigger('changeSelectedMenu', $page.attr('class'));
        widgetLoader.get('xsellFindBooking').execute('emptyFindBookings');
    }

    // Analytics: virtual page tracking
    trackingUtils.trackPage('account/payment-methods', {
        funnel: false,
    });
};
